var geojsonFeature = [{
  "type": "Feature",
  "properties": {
    "address": "152 Ave. C, New York, NY 10009",
    "heading": "Mac Low Apartment",
    "description": "Mac Low address in 1955, seen in his letters to Cage, Richards, and Tudor in Stony Point, NY.",
    "featureType": "marker"
  },
  "geometry": {
    "type": "Point",
    "coordinates": [
      -73.977481,
      40.7254999
    ]
  }
},
{
  "type": "Feature",
  "properties": {
    "address": "965 Hoe Ave, Bronx, NY 10459",
    "heading": "Mac Low Apartment",
    "description": "Mac Low address in April 1963 when he mailed scores to Patterson. Lived there with his first wife, Iris Lezak.",
    "featureType": "marker"
  },
  "geometry": {
    "type": "Point",
    "coordinates": [
      -73.8907,
      40.8227634
    ]
  }
},
{
  "type": "Feature",
  "properties": {
    "address": "467 Central Park W, New York, NY 10025",
    "heading": "Patterson Apartment",
    "description": "Benjamin and Pyla Patterson address as of 29 April 1963, when Mac Low mailed the postcard scores to Patterson.",
    "featureType": "marker"
  },
  "geometry": {
    "type": "Point",
    "coordinates": [
      -73.9599302,
      40.7987103
    ]
  }
},
{
  "type": "Feature",
  "properties": {
    "address": "112 Chambers St, New York, NY 10007",
    "heading": "Ono Loft",
    "description": "Address of Yoko Ono's loft, where the Chambers St. series, programmed by La Monte Young, occurred in October 1960-May 1961. Mac Low had one evening in this series dedicated to his work.",
    "featureType": "piano"
  },
  "geometry": {
    "type": "Point",
    "coordinates": [
      -74.0084005,
      40.7149336
    ]
  }
},
{
  "type": "Feature",
  "properties": {
    "address": "6th Ave & W 14th St, New York, NY 10011",
    "heading": "Living Theatre",
    "description": "Site of Living Theatre from 1959 to the fall of 1963. Merce Cunningham's dance studio was in the top floor of this building. Mac Low's chance-based play The Marrying Maiden was performed here in 1960 with music by John Cage.",
    "featureType": "theater"
  },
  "geometry": {
    "type": "Point",
    "coordinates": [
      -73.9969397,
      40.7373266
    ]
  }
},
{
  "type": "Feature",
  "properties": {
    "address": "38 Commerce St, New York, NY 10014",
    "heading": "Living Theatre",
    "description": "Cherry Lane Theatre, site of Living Theater performances until 1953. John Cage's Music of Changes was performed there in 1952.",
    "featureType": "theater"
  },
  "geometry": {
    "type": "Point",
    "coordinates": [
      -74.0052925,
      40.7312567
    ]
  }
},
{
  "type": "Feature",
  "properties": {
    "address": "Broadway & W 100th St, New York, NY 10025",
    "heading": "Living Theatre",
    "description": "Living Theatre Studio location ca. 1954 (after Cherry Lane) to 1956. The Living Theatre's production of W. H. Auden's The Age of Anxiety, with music by Mac Low, was performed at this location in 1954.",
    "featureType": "theater"
  },
  "geometry": {
    "type": "Point",
    "coordinates": [
      -73.9700237,
      40.7972647
    ]
  }
},
{
  "type": "Feature",
  "properties": {
    "address": "Willow Grove Rd, Stony Point, NY",
    "heading": "Gate Hill Cooperative",
    "description": "Artists' colony in Stony Point, NY, with many former Black Mountain College affiliates (including John Cage, M. C. Richards, and David Tudor, ca. 1954–56).",
    "featureType": "building"
  },
  "geometry": {
    "type": "Point",
    "coordinates": [
      -74.04838,
      41.22209
    ]
  }
},
{
  "type": "Feature",
  "properties": {
    "address": "24 Rue Mouffetard, 75005 Paris, France",
    "heading": "Fillou, Spoerri, and Williams Apartment",
    "description": "Address for Robert Fillou, Daniel Spoerri, and Emmett Williams ca. April 1963 when Mac Low sent them 3 Social Projects postcards and other correspondence.",
    "featureType": "marker"
  },
  "geometry": {
    "type": "Point",
    "coordinates": [
      2.3491357,
      48.8441847
    ]
  }
},
{
  "type": "Feature",
  "properties": {
    "address": "1132 Southern Blvd, Bronx, NY 10459",
    "heading": "Post Office",
    "description": "Mac Low mailed the postcards to Spoerri, Williams, and Fillou's address in France from this post office in the Bronx around 11am, before he began sending the postcards to Patterson (from the Bronx Central Station about two miles away).",
    "featureType": "mailbox"
  },
  "geometry": {
    "type": "Point",
    "coordinates": [
      -73.8916141,
      40.8274627
    ]
  }
},
{
  "type": "Feature",
  "properties": {
    "address": "558 Grand Concourse, Bronx, NY 10451",
    "heading": "Post Office",
    "description": "Mac Low mailed the postcards to Patterson from this post office, notable for its 13-panel Whitman-themed frescoe painted in 1939 by Ben Shahn and Bernarda Bryson Shahn. See <a href='https://tykokihlstedt.com/2014/01/whitman-work-democracy-ben-shahns-bronx.html' target='_blank'>https://tykokihlstedt.com/2014/01/whitman-work-democracy-ben-shahns-bronx.html</a>",
    "featureType": "mailbox"
  },
  "geometry": {
    "type": "Point",
    "coordinates": [
      -73.9265215,
      40.8188782
    ]
  }
}]

export { geojsonFeature }